
































































































































import Vue, { PropType } from 'vue';
import { isEmptyObject } from '@/utils/helpers';
import { Speaker } from '@/models/speaker';

export default Vue.extend({
  name: 'DataSpeakerCard',
  props: {
    speaker: {
      type: Object as PropType<Speaker>,
      required: true
    }
  },
  data: () => ({
    show: false
  }),
  computed: {},
  methods: {
    isEmptyObject,
    getSpeakerInitials(speaker: Speaker) {
      return (
        speaker.name.first.substring(0, 1).toUpperCase() +
        speaker.name.last.substring(0, 1).toUpperCase()
      );
    },
    getSpeakerFullName(speaker: Speaker) {
      return speaker.name.first + ' ' + speaker.name.last;
    }
  },
  async mounted() {
    //await this.fetchSpeaker();
  }
});
